import { defineMessages } from 'react-intl'

// E8 8.6.2 / WI 579 — copy for the unsaved-changes sign-out confirm (useSignOut).
const messages = defineMessages({
  dirtyTitle: {
    id: 'signOut.dirty.title',
    defaultMessage: 'Unsaved changes',
  },
  dirtyMessage: {
    id: 'signOut.dirty.message',
    defaultMessage: 'You have unsaved changes. Sign out anyway?',
  },
  dirtyConfirm: {
    id: 'signOut.dirty.confirm',
    defaultMessage: 'Sign out',
  },
  dirtyCancel: {
    id: 'signOut.dirty.cancel',
    defaultMessage: 'Stay',
  },
})

export default messages
